import Pax from '@nabancard/pos-cardreader/utils/pax';

import { CheckDef } from 'Src/feature/check/models';
import { definitions } from 'Src/vendor/posapi/pos';

const INVALID_DUPLICATE_STATUS: definitions['check.PaymentStatus'][] = ['Declined', 'Removed'];
const NO_CARD_BRAND = 'Unknown';

const duplicateCardVerify = (currentCheckPayments: CheckDef['payments'] | undefined, pax: Pax | undefined) =>
  currentCheckPayments?.find((previousPayment) => {
    if (pax && previousPayment.ccData?.lastFourCcNumber === pax.cardLast4Pan && !INVALID_DUPLICATE_STATUS.includes(previousPayment?.paymentStatus)) {
      const previousBrand = previousPayment.ccData?.cardBrand?.toLowerCase() || NO_CARD_BRAND;
      const paxBrand = pax.cardBrand?.toLowerCase() || NO_CARD_BRAND;
      return previousBrand.includes(paxBrand) || paxBrand.includes(previousBrand);
    }
  });

export { duplicateCardVerify };
